export default {
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false
}



// WEBPACK FOOTER //
// ./src/config/index.js